import React, { useEffect, useState } from "react";
import { Card, Col, Select, Statistic, Row, Table, message } from "antd";

import ReportFilterBar from "../components/ReportFilterBar";
import ReportExportButton from "../components/ReportExportButton";
import { fetchConversionReportApi } from "../../../apiservice/crm";

const ConversionReport = () => {
  const [filters, setFilters] = useState({ group_by: "employee" });
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({ totalLeads: 0, totalConverted: 0 });
  const [loading, setLoading] = useState(false);

  const load = async (nextFilters = filters) => {
    setLoading(true);
    try {
      const res = await fetchConversionReportApi(nextFilters);
      setData(res.data?.data || []);
      setTotals({
        totalLeads: res.data?.totalLeads || 0,
        totalConverted: res.data?.totalConverted || 0,
      });
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to load conversion report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns = [
    { title: filters.group_by === "source" ? "Source" : "Employee", dataIndex: "group_label" },
    { title: "Total Leads", dataIndex: "total_leads", align: "center" },
    { title: "Converted", dataIndex: "converted", align: "center" },
    {
      title: "Conversion Rate",
      dataIndex: "conversion_rate",
      align: "center",
      render: (v) => `${v}%`,
    },
  ];

  return (
    <>
      <ReportFilterBar
        filters={filters}
        onChange={(partial) => setFilters((f) => ({ ...f, ...partial }))}
        onApply={() => load()}
        onReset={() => {
          const reset = { group_by: filters.group_by };
          setFilters(reset);
          load(reset);
        }}
        loading={loading}
        extra={
          <Col xs={24} sm={12} md={8} lg={4}>
            <label>Group By</label>
            <Select
              style={{ width: "100%" }}
              size="large"
              value={filters.group_by}
              onChange={(v) => {
                const next = { ...filters, group_by: v };
                setFilters(next);
                load(next);
              }}
              options={[
                { label: "Employee", value: "employee" },
                { label: "Source", value: "source" },
              ]}
            />
          </Col>
        }
      />

      <Card title="Lead Conversion" extra={<ReportExportButton reportType="conversion" filters={filters} />}>
        <Row gutter={16} className="mb-4">
          <Col>
            <Statistic title="Total Leads" value={totals.totalLeads} />
          </Col>
          <Col>
            <Statistic title="Converted" value={totals.totalConverted} />
          </Col>
        </Row>

        <Table
          rowKey="group_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          bordered
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default ConversionReport;
